import React, { useState } from 'react';
import Footer from '../../components/Footer';
import NCTE from "../../assets/ap1.pdf";
import { 
  FaDownload, 
  FaUniversity, 
  FaCertificate, 
  FaCheckCircle 
} from 'react-icons/fa';

const Ncte = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleDownloadPDF = () => {
    // Create a temporary link element
    const link = document.createElement('a');
    link.href = NCTE;
    link.download = 'NCTE_Recognition_Document.pdf';
    
    // Trigger the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="w-full min-h-screen bg-gradient-to-b from-[#f0f4f8] to-white mt-[70px] sm:mt-[170px]">

      {/* Header Section */}
      <div className="container mx-auto px-4 py-12">
        <div className="text-center">
          <div className="flex items-center justify-center mb-6">
            <FaUniversity className="text-[#0e4d38] text-4xl mr-4" />
            <h2 className="text-3xl md:text-5xl tracking-tight font-extrabold text-[#0e4d38]">
              NCTE Recognition Document
            </h2>
          </div>
          <p className="text-gray-600 max-w-2xl mx-auto mt-4 text-center">
            Official NCTE recognition validating Maya Devi University's teacher education programs
          </p>
        </div>
      </div>

      {/* Document Preview Section */}
      <div className="container mx-auto px-4 py-8">
        <div 
          className="bg-white shadow-2xl rounded-xl overflow-hidden max-w-4xl mx-auto transition-all duration-300 transform hover:scale-[1.02]"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {/* Document Header */}
          <div className="p-6 bg-[#0e4d38] text-white flex justify-between items-center">
            <div className="flex items-center space-x-4">
              <FaCertificate className="text-2xl" />
              <h3 className="text-xl font-semibold">
                NCTE Recognition Certificate
              </h3>
            </div>
            <button 
              onClick={handleDownloadPDF}
              className="flex items-center gap-2 bg-white text-[#0e4d38] px-4 py-2 rounded-full hover:bg-gray-100 transition duration-300"
            >
              <FaDownload />
              Download PDF
            </button>
          </div>
          
          {/* Document Preview Content */}
          <div className="p-6 text-center">
            <div className="bg-gray-50 rounded-lg p-8 flex flex-col items-center">
              <FaUniversity className={`text-6xl text-[#0e4d38] mb-4 transition-all duration-300 ${isHovered ? 'animate-pulse' : ''}`} />
              <h4 className="text-xl font-semibold mb-2">Verified Official Document</h4>
              <p className="text-gray-600 mb-4 max-w-xl">
                The National Council for Teacher Education (NCTE) recognition document 
                confirms Maya Devi University's compliance with national education standards.
              </p>
              <button 
                onClick={handleDownloadPDF}
                className="bg-[#0e4d38] text-white px-6 py-2 rounded-full hover:bg-[#0e4d38]/90 transition duration-300 flex items-center gap-2 group"
              >
                <FaDownload className="group-hover:animate-bounce" />
                Download Official Certificate
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Key Features Section */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="bg-white shadow-lg rounded-lg p-6 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center mb-4">
              <FaCheckCircle className="text-[#0e4d38] mr-3 text-2xl" />
              <h3 className="text-xl font-semibold text-[#0e4d38]">
                National Validation
              </h3>
            </div>
            <p className="text-gray-600">
              Confirms the university's teacher education programs meet rigorous national standards set by NCTE.
            </p>
          </div>
          <div className="bg-white shadow-lg rounded-lg p-6 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center mb-4">
              <FaCertificate className="text-[#0e4d38] mr-3 text-2xl" />
              <h3 className="text-xl font-semibold text-[#0e4d38]">
                Institutional Credibility
              </h3>
            </div>
            <p className="text-gray-600">
              Demonstrates Maya Devi University's commitment to quality teacher education and professional development.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Ncte;